import {
  SET_KANBAN_UI_FLAG,
  CLEAR_KANBANS,
  SET_KANBANS,
  SET_KANBAN_ITEM,
  EDIT_KANBAN,
  DELETE_KANBAN,
  SET_KANBAN_STAGE,
  DELETE_KANBAN_STAGE,
  SET_KANBAN_STAGE_AUTOMATION,
} from './types';
import KanbansAPI from '../../../api/kanbans';

export const actions = {
  get: async ({ commit }) => {
    commit(SET_KANBAN_UI_FLAG, { isFetching: true });
    try {
      const { data } = await KanbansAPI.get();
      commit(CLEAR_KANBANS);
      commit(SET_KANBANS, data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_KANBAN_UI_FLAG, { isFetching: false });
    }
  },

  show: async ({ commit }, { id }) => {
    commit(SET_KANBAN_UI_FLAG, { isFetchingItem: true });
    try {
      const response = await KanbansAPI.show(id);
      commit(SET_KANBAN_ITEM, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_KANBAN_UI_FLAG, { isFetchingItem: false });
    }
  },

  create: async ({ commit }, kanbanInfo) => {
    commit(SET_KANBAN_UI_FLAG, { isCreating: true });
    try {
      const response = await KanbansAPI.create({ kanban: kanbanInfo });
      commit(SET_KANBAN_ITEM, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_KANBAN_UI_FLAG, { isCreating: false });
    }
  },

  update: async ({ commit }, { id, ...updateObj }) => {
    commit(SET_KANBAN_UI_FLAG, { isUpdating: true });
    try {
      const response = await KanbansAPI.update(id, { kanban: updateObj });
      commit(EDIT_KANBAN, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_KANBAN_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async ({ commit }, kanbanId) => {
    commit(SET_KANBAN_UI_FLAG, { isDeleting: true });
    try {
      await KanbansAPI.delete(kanbanId);
      commit(DELETE_KANBAN, kanbanId);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_KANBAN_UI_FLAG, { isDeleting: false });
    }
  },

  createStage: async ({ commit }, { kanbanId, ...stageInfo }) => {
    commit(SET_KANBAN_UI_FLAG, { isCreatingStage: true });
    try {
      const response = await KanbansAPI.createStage({
        kanbanId,
        ...stageInfo,
      });
      commit(SET_KANBAN_STAGE, { kanbanId, stage: response.data });
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_KANBAN_UI_FLAG, { isCreatingStage: false });
    }
  },

  updateStage: async ({ commit }, { kanbanId, id, ...stageInfo }) => {
    commit(SET_KANBAN_UI_FLAG, { isUpdatingStage: true });
    try {
      const response = await KanbansAPI.updateStage({
        kanbanId,
        id,
        ...stageInfo,
      });
      commit(SET_KANBAN_STAGE, { kanbanId, stage: response.data });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_KANBAN_UI_FLAG, { isUpdatingStage: false });
    }
  },

  deleteStage: async ({ commit }, { kanbanId, id }) => {
    commit(SET_KANBAN_UI_FLAG, { isDeletingStage: true });
    try {
      await KanbansAPI.deleteStage({ kanbanId, id });
      commit(DELETE_KANBAN_STAGE, { kanbanId, id });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_KANBAN_UI_FLAG, { isDeletingStage: false });
    }
  },

  getStageAutomation: async ({ commit }, { kanbanId, stageId }) => {
    commit(SET_KANBAN_UI_FLAG, { isFetchingAutomation: true });
    try {
      const { data } = await KanbansAPI.getStageAutomation({
        kanbanId,
        stageId,
      });
      commit(SET_KANBAN_STAGE_AUTOMATION, { stageId, automation: data });
      return data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_KANBAN_UI_FLAG, { isFetchingAutomation: false });
    }
  },

  updateStageAutomation: async ({ commit }, { kanbanId, stageId, ...data }) => {
    commit(SET_KANBAN_UI_FLAG, { isUpdatingAutomation: true });
    try {
      const response = await KanbansAPI.updateStageAutomation({
        kanbanId,
        stageId,
        ...data,
      });
      commit(SET_KANBAN_STAGE_AUTOMATION, {
        stageId,
        automation: response.data,
      });
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_KANBAN_UI_FLAG, { isUpdatingAutomation: false });
    }
  },
};
